import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/rem';

  .TaskIcon {
    width: rem(22px);
    height: rem(22px);
  }
`;

export { staticStyles };
